export default (state = { expanded: false, mapData: null }, { type, payload }) => {
  switch (type) {
    case 'LANDTRUST_RIGHT_MENU_OPEN':
      return {
        expanded: true,
        mapData: payload.mapData ? payload.mapData : null,
        coordinates: payload.coordinates ? payload.coordinates : null,
        activityDetails: payload.activityDetails ? payload.activityDetails : null,
      }
    case 'LANDTRUST_RIGHT_MENU_CLOSE':
      return {
        expanded: false,
        mapData: null,
        coordinates: null,
        activityDetails: null
      }
    case 'LOGOUT':
      return {
        expanded: false,
      }
    default:
      return state
  }
}